<script>
    import { onDestroy } from "svelte";
    import { page, modal } from '../store/nav';
    import { lists } from '../store/lists';
    import { idb } from "../db";

    export let list_uid;
    export let store_name;
    export let store_logo;

    let menu = [
        {
            name: 'Change store',
            fn: () => {
                page.route(`/lists/items/store?list_uid=${list_uid}`);
                modal.close();
            }
        },
        {
            name: 'Delete list',
            fn: async () => {
                // Mutate store
                await lists.delete(list_uid);
                // Routing
                page.route('/lists');
                modal.close();
            }
        }
    ];

    if ( store_name == 'whole foods' || store_name == 'amazon fresh') {
        menu.unshift(
            {
                name: 'Fulfill online',
                fn: async () => {
                    modal.open(`/online-fulfillment?list_uid=${list_uid}&store_name=${store_name}&store_logo=${store_logo}&anchor=bottom`);
                }
            },
        )
    }

    onDestroy(() => {
        console.group(`INFO: menu-list .onDestroy`);console.groupEnd();
    });
</script>

<section class="flex flex-col space-y-7 m-auto font-semibold text-primary">
    {#each menu as menuEntry}
        <span class="m-auto " on:click|stopPropagation={menuEntry.fn}>{menuEntry.name}</span>
    {/each}
</section>
